export const AVANTEA_SESSION = 'avantea-session'

export const STRUCTURAL_FACTOR_MODE: { [key: number]: { id: string; name: string } } = {
  0: {
    id: '0',
    name: 'Annex B',
  },
  1: {
    id: '1',
    name: 'Annex C',
  },
};
